export default {
	methods: {
		getBackgroundPositionClass(imageSrc) {
			// Check file name for position code and return appropriate class name
			// If code does not exist, background position will be centered
			// Examples:
			// hero-1_TR.jpg will be aligned to the top right (TR)
			// hero-1_BL.jpg will be aligned to the bottom left (BL)
			// hero-1_CR.jpg will be aligned to the center right (CR)
			const position = imageSrc.match(/_([ctbCTB][crlCRL]).*$/);
			return position && position[1]
				? `bg--position-${position[1].toLowerCase()}`
				: "bg--position-cc";
		}
	}
};
